

import React, { useState } from "react";
import "../../../assetss/styles/tictacTwo.css";

const INIT_HISTORY = [
  {
    squares: Array(9).fill(null),
  },
];

const INIT_STATE = {
  history: INIT_HISTORY,
  stepNumber: 0,
  xIsNext: true,
  winner: null,
};

const GameInfo = ({ winner, xIsNext, onClick, stepNumber }) => {
  let status;
  if (winner) {
    status = "برنده: " + winner;
  } else {
    status = xIsNext ? "نوبت بازیکن X" : "نوبت بازیکن O";
  }

  const moves = INIT_HISTORY.map((step, move) => {
    const desc = move ? `برو به حرکت #${move}` : "شروع بازی";
    return (
      <div key={move}>
        <button className="bg-red-400 p-1 px-2 m-2 rounded-sm font-semibold" onClick={() => onClick(move)}>{desc}</button>
      </div>
    );
  });

  return (
    <div className="game-info">
      <div>{status}</div>
      <div>{moves}</div>
    </div>
  );
};

const Square = ({ value, onClick }) => {
  return (
    <button className="square" onClick={onClick}>
      {value}
    </button>
  );
};

const Board = ({ squares, onClick }) => {
  const renderSquare = (i) => {
    return <Square value={squares[i]} onClick={() => onClick(i)} />;
  };

  return (
    <div className="board">
      <div className="board-row">
        {renderSquare(0)}
        {renderSquare(1)}
        {renderSquare(2)}
      </div>
      <div className="board-row">
        {renderSquare(3)}
        {renderSquare(4)}
        {renderSquare(5)}
      </div>
      <div className="board-row">
        {renderSquare(6)}
        {renderSquare(7)}
        {renderSquare(8)}
      </div>
    </div>
  );
};

const TicTacToeGameTwo = () => {
  const [state, setState] = useState(INIT_STATE);

  const handleClick = (i) => {
    const history = state.history.slice(0, state.stepNumber + 1);
    const current = history[history.length - 1];
    const squares = current.squares.slice();
    if (calculateWinner(squares) || squares[i]) {
      return;
    }
    squares[i] = state.xIsNext ? "X" : "O";
    setState({
      history: history.concat([{ squares: squares }]),
      stepNumber: history.length,
      xIsNext: !state.xIsNext,
      winner: calculateWinner(squares),
    });
  };

  const jumpTo = (step) => {
    setState({
      ...state,
      stepNumber: step,
      xIsNext: step % 2 === 0,
      winner: null,
    });
  };

  const { history, xIsNext, winner, stepNumber } = state;
  const current = history[stepNumber];

  return (
    <div className="container">
      <div className="row">
        <div className="game-title">
          <h3 className='font-semibold'>بازی دوز 2 نفره</h3>
          {/* <small>بازی کن تا غذات برسه</small> */}
        </div>
      </div>
      <div className="game">
        <div className="boardd">
          <div className="game-board">
            <Board squares={current.squares} onClick={handleClick} />
          </div>
        </div>
        <div>
          <div className="game-board">
            <GameInfo
              winner={winner}
              xIsNext={xIsNext}
              onClick={jumpTo}
              stepNumber={stepNumber}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const calculateWinner = (squares) => {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
};

export default TicTacToeGameTwo;
